import { Component, Input } from '@angular/core';

@Component({
    selector: 'ui-subheader',
    templateUrl: './subheader.component.html',
    styleUrls: ['./subheader.component.less']
})
export class SubheaderComponent {
    @Input() subheader: string;
    @Input() isMobile = false;
}
